// @flow

import actionTypes from '../actionTypes';
import { fetch } from '../../api';
import { fetchData } from './dataActionsCreator';

export function fetchUnreadCount() {
  return async function fetchUnreadNotificationCount(dispatch: Dispatch) {
    const fetchFunction = async () => {
      const { payload } = await fetch('notifications/unread');

      dispatch({
        type: actionTypes.COUNTER_UNREAD_SUCCESS,
        isAsynchronous: true,
        unread: { notifications: payload.unread },
      });

      return payload;
    };

    return fetchData(fetchFunction);
  };
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/notificationActionsCreator.js